"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));

var _DialogTitle = _interopRequireDefault(require("@material-ui/core/DialogTitle"));

var _DialogContent = _interopRequireDefault(require("@material-ui/core/DialogContent"));

var _DialogActions = _interopRequireDefault(require("@material-ui/core/DialogActions"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));

var _AppBar = _interopRequireDefault(require("@material-ui/core/AppBar"));

var _Toolbar = _interopRequireDefault(require("@material-ui/core/Toolbar"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _Slide = _interopRequireDefault(require("@material-ui/core/Slide"));

var _DialogButtonSave = _interopRequireDefault(require("../DialogButtonSave"));

var _DialogButtonCancel = _interopRequireDefault(require("../DialogButtonCancel"));

var Transition = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  return /*#__PURE__*/_react.default.createElement(_Slide.default, (0, _extends2.default)({
    direction: "up",
    ref: ref
  }, props));
});

var styles = function styles(theme) {
  return {
    root: {},
    content: theme.mixins.gutters({
      minWidth: theme.spacing(40)
    }),
    fullScreenAppBar: {
      backgroundColor: theme.palette.secondary.dark,
      color: theme.palette.secondary.contrastText
    }
  };
};
/**
 * Vytvoří základní Dialog Form.
 *
 * @component
 */


var _ref4 = /*#__PURE__*/_react.default.createElement(_Close.default, null);

var DialogForm = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var buttonCancelLabel = _ref.buttonCancelLabel,
      buttonSaveLabel = _ref.buttonSaveLabel,
      children = _ref.children,
      classes = _ref.classes,
      className = _ref.className,
      _ref$dirty = _ref.dirty,
      dirty = _ref$dirty === void 0 ? false : _ref$dirty,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$fullScreen = _ref.fullScreen,
      fullScreen = _ref$fullScreen === void 0 ? false : _ref$fullScreen,
      _ref$isSubmitting = _ref.isSubmitting,
      isSubmitting = _ref$isSubmitting === void 0 ? false : _ref$isSubmitting,
      onClose = _ref.onClose,
      handleSubmit = _ref.onSubmit,
      _ref$open = _ref.open,
      open = _ref$open === void 0 ? false : _ref$open,
      title = _ref.title,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["buttonCancelLabel", "buttonSaveLabel", "children", "classes", "className", "dirty", "disabled", "fullScreen", "isSubmitting", "onClose", "onSubmit", "open", "title"]);

  var handleRequestClose = _react.default.useCallback(function () {
    if (onClose) onClose();
  }, [onClose]);

  var handleInnerSubmit = _react.default.useCallback(function (e) {
    e.preventDefault();
    e.stopPropagation();
    if (handleSubmit && !disabled) handleSubmit(e);
  }, [disabled, handleSubmit]);

  var _ref2 = /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    color: "inherit",
    onClick: handleRequestClose,
    "aria-label": "Close"
  }, _ref4);

  var _ref3 = /*#__PURE__*/_react.default.createElement(_DialogTitle.default, null, title);

  var titleComponent = _react.default.useMemo(function () {
    return fullScreen ? /*#__PURE__*/_react.default.createElement(_AppBar.default, {
      color: "default",
      style: {
        position: 'relative'
        /* , marginBottom: 24 */

      },
      classes: {
        colorDefault: classes.fullScreenAppBar
      }
    }, /*#__PURE__*/_react.default.createElement(_Toolbar.default, null, _ref2, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "h4",
      color: "inherit",
      style: {
        flex: 1
      }
    }, title))) : _ref3;
  }, [classes.fullScreenAppBar, fullScreen, handleRequestClose, title]);

  return /*#__PURE__*/_react.default.createElement(_Dialog.default, (0, _extends2.default)({
    ref: ref,
    open: open,
    className: (0, _clsx.default)(classes.root, className),
    onClose: handleRequestClose,
    fullScreen: fullScreen,
    TransitionComponent: fullScreen ? Transition : undefined
  }, rest), titleComponent, /*#__PURE__*/_react.default.createElement(_DialogContent.default, {
    className: classes.content,
    dividers: fullScreen
  }, /*#__PURE__*/_react.default.createElement("form", {
    onSubmit: handleInnerSubmit,
    noValidate: true,
    autoComplete: "off"
  }, children)), /*#__PURE__*/_react.default.createElement(_DialogActions.default, null, /*#__PURE__*/_react.default.createElement(_DialogButtonCancel.default, {
    onClick: handleRequestClose
  }, buttonCancelLabel), !disabled && /*#__PURE__*/_react.default.createElement(_DialogButtonSave.default, {
    type: "submit",
    disabled: isSubmitting || !dirty,
    onClick: function onClick() {
      handleSubmit();
    }
  }, buttonSaveLabel)));
});

process.env.NODE_ENV !== "production" ? DialogForm.propTypes = {
  /**
     * Customizace standardniho labelu cancel buttonu.
     */
  buttonCancelLabel: _propTypes.default.node,

  /**
     * Customizace standardniho labelu save buttonu.
     */
  buttonSaveLabel: _propTypes.default.node,

  /**
     * Obsah dialogu => zobrazi se po otevreni dialogu
     */
  children: _propTypes.default.node,

  /**
     * Boolean zaktivni tlacitko save
     */
  dirty: _propTypes.default.bool,
  disabled: _propTypes.default.bool,

  /**
     * Pro zobrazeni dialogu pres celou obrazovku
     */
  fullScreen: _propTypes.default.bool,

  /**
     *
     */
  isSubmitting: _propTypes.default.bool,

  /**
     * Funkce onClose pro zavreni dialogu
     */
  onClose: _propTypes.default.func.isRequired,

  /**
     * Funkce pro submitovani Dialogu
     */
  onSubmit: _propTypes.default.func.isRequired,

  /**
     * Boolean pro otevreni dialogu => state = { open: false/true }
     */
  open: _propTypes.default.bool,

  /**
     * Titulka dialogu
     */
  title: _propTypes.default.node
} : void 0;
DialogForm.displayName = 'DialogForm';

var _default = (0, _styles.withStyles)(styles, {
  name: 'SxDialogForm'
})(DialogForm);

exports.default = _default;